import { CartesianGrid, Legend, Scatter, ScatterChart, Tooltip, XAxis, YAxis, ZAxis } from "recharts";
import { MachinesByGroup } from "../../Types/dashboardTypes";
import { HistoricalTsiDataType } from "../../Types/portalTypes";

interface Props {
  selectedData: HistoricalTsiDataType;
  machines: MachinesByGroup[];
  colors: string[];
}

const MyScatterChart: React.FC<Props> = (props) => {
  const { selectedData, machines, colors } = props;

  return (
    <ScatterChart width={650} height={290} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis hide type="category" name="Date" dataKey="date" allowDuplicatedCategory={false} />
      <YAxis hide type="number" name="OEE" dataKey="oee" domain={[0, 1]} />
      <ZAxis range={[30, 31]} />
      <Tooltip cursor={{ strokeDasharray: "3 3" }} />
      <Legend align="left" wrapperStyle={{ left: 20, bottom: -15, font: "normal normal normal 14px/17px Roboto" }} />
      {Object.keys(selectedData).map((e, index) => {
        return (
          <Scatter
            key={e}
            name={machines[index]?.machineName}
            data={selectedData[e]?.map((e) => ({ date: e.date, oee: e?.oee ?? 0 }))}
            fill={colors[index]}
            line={{ strokeWidth: 2 }}
          />
        );
      })}
    </ScatterChart>
  );
};

export default MyScatterChart;
